// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"50c66692","261":"6b5c8fbb","463":"52fc0f5e","484":"d1a747a8","588":"1690e70c","603":"c5e34891","668":"5a41761b","893":"4db19853","963":"f94b5d75","989":"b71d8262"}[chunkId] + ".chunk.js";
};